export const ADDENDUM_TYPE_ID = 19602;

/**
 * Filters options by label, matching numeric input as a prefix of the number
 * extracted from the label, or falling back to a case-insensitive substring match.
 */
export const addendumFilterOption = (option, inputValue) => {
  if (!inputValue) return true;
  const input = inputValue.trim();
  if (/^\d+$/.test(input)) {
    const numberStr = String(parseInt(option.label.replace(/\D+/g, ""), 10));
    return (
      numberStr.startsWith(input) ||
      numberStr.padStart(2, "0").startsWith(input)
    );
  }
  return option.label.toLowerCase().includes(input.toLowerCase());
};

/**
 * Builds sorted react-select options from an episode list.
 */
export const buildEpisodeOptions = (episodeList) =>
  [...episodeList]
    .sort((a, b) => (a.episodeNumber || a.name || 0) - (b.episodeNumber || b.name || 0))
    .map((item) => ({
      value: item.episodeId || item.id,
      label: `Episódio ${String(item.episodeNumber || item.name || item.id).padStart(2, "0")}`,
    }));

/**
 * Builds sorted react-select options from a dramaturgy (chapter) list.
 */
export const buildChapterOptions = (dramaturgyList) =>
  [...dramaturgyList]
    .sort((a, b) => a.chaption - b.chaption)
    .map((item) => ({
      value: item.id,
      label: `Capítulo ${String(item.chaption).padStart(2, "0")}`,
    }));

/**
 * Returns the formatted selection counter label.
 */
export const getSelectionLabel = (count) =>
  `${String(count).padStart(2, "0")} ${
    count === 1 ? "item selecionado" : "itens selecionados"
  }`;

/**
 * Returns only the episodes that have at least one uploaded attachment.
 */
export const getEpisodesWithAttachments = (materialsList, episodeOptions) => {
  const episodesWithAttachments = new Set(
    materialsList
      .filter(
        (item) => Number(item.type?.id) === 1211 && item.attachments?.length > 0
      )
      .map((item) => item.episodeNumber)
  );
  return episodeOptions.filter((ep) =>
    episodesWithAttachments.has(ep.episodeNumber)
  );
};

/**
 * Returns only the chapters that have at least one uploaded attachment.
 */
export const getChaptersWithAttachments = (dramaturgyList) =>
  dramaturgyList.filter((chapter) => chapter.versions?.length > 0);

/**
 * Returns true when the selected attachment type corresponds to "Adendo".
 */
export const isAddendumType = (attachmentTypeId) =>
  Number(attachmentTypeId) === ADDENDUM_TYPE_ID;
